/**
 * Composant Input
 * Champ de saisie stylisé
 */

import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
    error?: boolean;
}

const Input = forwardRef<HTMLInputElement, InputProps>(
    ({ className, type, error, inputMode, ...props }, ref) => {
        return (
            <input
                type={type}
                // 16px sur mobile pour éviter le zoom auto iOS au focus, 14px sur desktop.
                // inputMode "decimal" par défaut sur les champs numériques (clavier optimal mobile), surchargeable.
                inputMode={inputMode ?? (type === 'number' ? 'decimal' : undefined)}
                className={cn(
                    'flex h-10 w-full rounded-lg border bg-white px-3 py-2 text-base sm:text-sm',
                    'dark:bg-[#0F172A] dark:text-[#F1F5F9]',
                    'placeholder:text-[#64748B] dark:placeholder:text-[#64748B]',
                    'focus:outline-none focus:ring-2 focus:ring-offset-0',
                    'disabled:cursor-not-allowed disabled:opacity-50',
                    error
                        ? 'border-[#EF4444] focus:ring-[#EF4444]/20'
                        : 'border-[#E2E8F0] dark:border-[#334155] focus:ring-[#0F2744]/20 focus:border-[#0F2744] dark:focus:border-[#3B82F6]',
                    className
                )}
                ref={ref}
                {...props}
            />
        );
    }
);

Input.displayName = 'Input';

export { Input };
